// export const SIGN_KEY = ""
// export const ENCRYPT_KEY = ""
// export const COOKIE_DAYS = ""
STORAGE_TIME = 86400; //秒
